import ClearSlideImg from "../../images/ClearSlide.svg";
import { updateModuleCardsinEditor } from "../../services/apis";
const ClearSlide = ({ editor, appData }) => {

  function getAllContentIds(components, ids = []) {
    components.forEach(comp => {
      const contentId = comp.getAttributes()['data-content-id'];
  
      if (contentId) {
        ids.push(contentId);
      }
  
      if (comp.components().length) {
        getAllContentIds(comp.components(), ids);
      }
    });
  
    return ids;
  }

  function decreaseMatchedCount(data, contentIds) {
    const idSet = new Set(contentIds);
  
    return data.map(item => {
      if (idSet.has(item.id)) {
        return {
          ...item,
          count: Math.max(0, item.count - 1)
        };
      }
      return item;
    });
  }
  function updateDBDeckContent(deckId, payload) {
    const payloadInput = {
      selected_module_data: payload,
    };
    return new Promise((resolve, reject) => {
      updateModuleCardsinEditor(deckId, payloadInput, (response, err) => {
        if (err) {
          reject(err);
        } else {
          resolve(response?.data?.response?.selected_module_data || []);
        }
      });
    });
  }

  const clearSlideContent = () => {
    //commneted for now due to runvalidation descope this will revert back the cleared components present on editor in popup
    /* const contentIds = getAllContentIds(editor.getWrapper().components());
    const selected_module_data = appData?.deckId?.selected_module_data;
    const updatedData = decreaseMatchedCount(selected_module_data, contentIds);
    appData.setDeckId((prev) => ({
      ...prev,
      selected_module_data: updatedData,
    }));
    console.log(contentIds, 'editor content ids', updatedData);
    updateDBDeckContent(appData?.deckId?._id, updatedData); */
    if (
      appData?.deckId?.default_aspect_ratio &&
      typeof editor?.runCommand === "function"
    ) {
      editor.runCommand("clear-slide-all-dimensions");
    } else {
      const wrapper = editor.DomComponents.getComponents().at(0);
      wrapper.empty();
      wrapper.setStyle({
        width: "1024px",
        height: "768px",
      });
      editor.select(wrapper);
    }

    
    
   /* editor.DomComponents.clear();
   // editor.DomComponents.getWrapper().set("content", "");
    editor.addComponents({
    tagName: 'div',
    attributes: { 'data-gjs-editable': 'true', 'data-gjs-draggable': 'true', 'data-gjs-name':'Wrapper' ,'id':"wrapper"},
   // style: {   width: "1024px", position:"absolute", height: "768px", }
    });
    if (editor.DomComponents.getComponents()?.at(0)?.ccid === "wrapper" ) {
          editor.DomComponents.getComponents().at(0).set({ name: "Wrapper" ,  selectable: true});
      } */
  };
  return (
    <>
      <div
        onClick={() => clearSlideContent()}
        className="d-flex align-items-center"
      >
        <img src={ClearSlideImg} alt="clone Slide" className="ignoreClick" />
        <h2>Clear Slide</h2>
      </div>
    </>
  );
};
export default ClearSlide;
